import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check_c417009362322f0c9a821bb36d734aee",
  "use": "check_c417009362322f0c9a821bb36d734aee-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check_c417009362322f0c9a821bb36d734aee\">\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M19.412 5.59l1.22 1.137a.5.5 0 0 1 .023.709L10.358 18.364a.5.5 0 0 1-.728 0l-6.285-6.67a.5.5 0 0 1 .023-.709l1.22-1.138a.5.5 0 0 1 .705.023l4.7 4.99 8.714-9.248a.5.5 0 0 1 .705-.023z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol